import { supabase } from "@/integrations/supabase/client";
import { ofetch } from "ofetch";

const baseURL = import.meta.env.VITE_BACKEND_URL;

export async function fetchApi<T, URL extends string = string>(
  url: URL,
  options: any = {},
) {
  const session = await supabase.auth.getSession();

  const authorization = session.data
    ? `Bearer ${session.data.session?.access_token}`
    : undefined;

  const isFormData = options?.body instanceof FormData;
  const headers = {
    accept: "application/json",
    authorization,
    ...options?.headers,
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  return await ofetch<T>(url, {
    baseURL: baseURL as URL,
    headers,
    credentials: "include",
    cache: "no-store",
    ...options,
  });
}
